import React from 'react';
import PropTypes from 'prop-types';
import { withGoogleSheets } from 'react-db-google-sheets';
import { SectionTitle } from '../../components';
import { convertDriveUrlToPhotoUrl } from '../../utils';

const About = ({ db: { about: data } }) => {
  const text = data.find(d => d.key === 'text').value;
  const image = data.find(d => d.key === 'image').value;
  const imageAlt = data.find(d => d.key === 'image_alt').value;

  return (
    <div className="about-area section padding-top">
      <div className="container">
        <SectionTitle title="About Me" />
        <div className="row">
          <div className="col-lg-12">
            <div className="about-image">
              <img src={convertDriveUrlToPhotoUrl(image)} alt={imageAlt} />
            </div>
            <div className="about-content">
              <p dangerouslySetInnerHTML={{ __html: text }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

About.propTypes = {
  db: PropTypes.shape({
    about: PropTypes.arrayOf(PropTypes.object)
  })
};

export default withGoogleSheets('about')(About);
